import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import Stats from "@/components/Stats";
import Manifesto from "@/components/Manifesto";
import EditorialMarquee from "@/components/EditorialMarquee";
import Collection from "@/components/Collection";
import Custom from "@/components/Custom";
import Occasions from "@/components/Occasions";
import Reviews from "@/components/Reviews";
import EnquirySection from "@/components/EnquirySection";
import Footer from "@/components/Footer";

export default function Home() {
  return (
    <div className="relative" data-testid="home-page">
      <Navbar />
      <Hero />
      <Stats />
      <Manifesto />
      <EditorialMarquee />
      <Collection />
      <Custom />
      <Occasions />
      <Reviews />
      <EnquirySection />
      <Footer />
    </div>
  );
}
